
<template>
    <div>
        <div class="d-flex align-items-center justify-content-between" style="margin-bottom: 24px;" v-if="true">
            <div class="filters">
                <b-form-group label="Status" class="mr-3" style="width: 312px;">
                    <CustomSelect
                            @input="idValueStudentReportStatus"
                            :options="arrayoptionStatus"
                            value="id"
                            label="descripcion" 
                            :default="$t('filter.text')"
                            @change="changeFilter()"
                        />
                    <!-- <b-form-select v-model="studentReportStatus" @change="changeFilter" :options="arrayoptionStatus" value-field="id" text-field="descripcion" style="width: 312px;">
                          <template #first>
                              <b-form-select-option  :value="null">All</b-form-select-option>
                          </template>
                        
                    </b-form-select> -->
                </b-form-group>
                  <b-form-group :label="$t('evaluations-reports.index.author')" class="ml-2 mr-3" style="width: 200px;">
                        <CustomSelect
                            @input="idValueSelectAuthor"
                            :options="arrayoptionAuthor"
                            value="id"
                            label="descripcion" 
                            :default="$t('filter.text')"
                            @change="changeFilter()"
                        />
                        <!-- <b-form-select v-model="selectAuthor" :options="arrayoptionAuthor" @change="changeFilter"   value-field="id" text-field="descripcion">
                            <b-form-select-option :value="0">All</b-form-select-option>
                        </b-form-select> -->
                    </b-form-group>
                   
                <!--<b-form-group label="Author" class="ml-2 mr-3">
                    <b-form-select v-model="studentReportAuthor" style="width: 312px;">
                        <b-form-select-option :value="null">All</b-form-select-option>
                    </b-form-select>
                </b-form-group>-->
                <b-form-group class="mt-auto selectYear ml-2" style="width: 227px;">
                    <CustomSelect
                            @input="idValueSelectedYear"
                            :options="arrayoptionYear"
                            value="id"
                            label="descripcion" 
                            default="Every year"
                            @change="changeFilter()"
                        />
                    <!-- <b-form-select class="w-100"
                    value-field="id" text-field="descripcion"
                        v-model="selectedYear" 
                        :options="arrayoptionYear"
                        @change="changeFilter" 
                        >
                        <b-form-select-option :value="0" >Every year</b-form-select-option>
                    </b-form-select> -->
                </b-form-group >
            </div>
        </div>
       <b-table responsive  hover   :busy="isBusy"   :show-empty="true"
            id="table-report"  :tbody-transition-props="transProps"  style="white-space: pre-line;"
            :items="itemsStudentReports" :fields="fieldStudentReports"
            :empty-text="$t('reusables.empty-text')">
            <template #table-busy>
                    <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong> {{$t('ClassRequest.Loading')}}...</strong>
                    </div>
            </template>
            <template #cell(courses)="data">
               
                <div>
                    <p v-for="(item, index) in data.value" :key="index">{{item}}</p>
                
                </div>
            </template>
            <template #cell(report)="data">
                
                <div v-if="data.value">
                     <b-button @click="goViewReport(data.item)" class="btn btn-primary">
                        <img src="@/assets/icons/icon-table-create.svg" class="svg">
                        Create report
                    </b-button>
                   
                </div>
                <div v-else>
                    <a class="link" @click="goViewReport(data.item)"><span class="blue">View report</span></a>
                </div>
            </template>
                 <template #cell(author)="data">
                        <p>{{data.item.id > 0 ? data.value : '-'}}</p>
                </template>
        </b-table>
        <div class="overflow-auto content-pagination">
            <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            aria-controls="table-report"
            ></b-pagination>
            {{currentPage}}-{{perPage}} / {{totalRows}}  {{$t('ClassRequest.text.3')}}
        </div>
    </div>
</template>
<script>
import * as tools from '@/assets/js/tools.js';
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
import CustomSelect from "@/components/form/select";
export default {
     components:{
        CustomSelect
  
    },
    data(){
        return{
            isBusy: false,
            totalRows :0,
            perPage: 10,
            currentPage: 1,
            personStudentId:  null,
            arrayoptionStatus: [],
            arrayoptionYear : [],
            arrayoptionAuthor : [],
            selectedYear:0,
            selectAuthor:0,
            transProps: {
                name: 'flip-list'
            },
            studentReportStatus:null,
            studentReportAuthor:null,

            fieldStudentReports:[
            {key:'date' , label:this.$t('student-reports.table-th.date')},
            {key:'courses' , label:this.$t('student-reports.table-th.courses')},
            {key:'report' , label:''},
            {key:'author' , label:this.$t('student-reports.table-th.author')}
            ],
            itemsStudentReports: [],
        }
    },
   
    created(){
        this.personStudentId = this.$route.params.personStudentId
        this.getListFilters();
        this.getListReports();
    },
    watch:{
        currentPage: {
			handler: function(newVal, oldVal) {
                if(newVal != null){
                    this.getListReports();
                }
				
			}
		}
    },
    methods:{
        idValueSelectedYear(event){
            this.selectedYear = event;
        },
        idValueSelectAuthor(event){
           this.selectAuthor = event;
        },
        idValueStudentReportStatus(event){
            this.studentReportStatus = event;
        },
        changeFilter(){
            this.currentPage = 1,
            this.getListReports();
        },
        goViewReport(item){
            
            let data = {
                id : item.id,
                flagSearch:item.flagSearch,
                nameCourses: item.courses,
                personsStudentId:item.personsStudentId,
                personTeacherId: this.$store.state.user.personTeacherId,
                groupPlanId: item.groupPlanId,
                listGroupRegisterSubjectIds:item.coursesId,
                year:  item.year,
                month: item.month,
                flagTeacherReport : item.flagTeacherReport,
                TabClassRequest: this.TabClassRequest,
                typeStudent: this.typeStudent,
                groupId: item.groupId,
                personStudentId: this.$route.params.personStudentId,
                nameSubject: this.$route.params.nameSubject,
                flagHistory: this.$route.params.flagHistory,
            }
 
            this.$router.push({name: 'teacher/student/evaluations-reports/view-report', params: data });
        },
        backStep(){
            this.$router.go(-1)
        },
        getListFilters(){
            let params = {
                personStudentId : this.personStudentId,
                flagState : null,
                personTeacherIdSearch: this.$store.state.user.personTeacherId
            };
            baseInstanceAxios
                .get(`${this.apiURL}/resources/PersonsStudentsReports/ListSubjectsLevelHistoryByPersonStudent`, {params})
                .then(response => {

                    if(response.data.entity){
                        this.arrayoptionStatus = response.data.entity.statesReports;
                        this.arrayoptionYear = response.data.entity.year;
                        this.arrayoptionAuthor = response.data.entity.authors;
                        
                    }
                    
                }); 
        },
        getListReports(){
            this.isBusy = true;
            let body = {
                PersonsStudentId : this.personStudentId,
                ListSubjectLevelsIds: null, 
                FlagStatus: this.studentReportStatus,
                Year: this.selectedYear,
                PersonTeacherId : this.selectAuthor ? this.selectAuthor : 0,
                PersonTeacherIdSearch: this.$store.state.user.personTeacherId,
                Page: this.currentPage,
                Size: this.perPage
            };
            /*
            let body = {
                PersonsStudentId: 4,
                ListSubjectLevelsIds: null,
                FlagStatus: null,
                Year: 0,
                PersonTeacherId: 0, 
                Page: 1,
                Size: 10
            }*/
           
            baseInstanceAxios
            .post(`${this.apiURL}/resources/PersonsStudentsReports/ListPersonsStudentsByReports`, body)
            .then(response => {

           
                this.itemsStudentReports = response.data.list.map(element => ({
                    id : element.id,
                    personTeacherId : element.personTeacherId,
                    personsStudentId : element.personsStudentId,
                    groupPlanId : element.groupPlanId,
                    groupId : element.groupId,
                    date : element.strDateMonth_EN, 
                    month : element.month,
                    year : element.year,
                    flagTeacherReport : element.flagTeacherReport,
                    flagSearch : element.id > 0 ? true : false,
                    coursesId : element.strGroupRegisterSubjectIds ? element.strGroupRegisterSubjectIds.split('|') : [],
                    courses :  element.subjectName_EN ? element.subjectName_EN.split('|') : [],
                    author :element.teacherName,
                    report : element.id == 0 ? true : false,
                }))
             
                this.isBusy = false;
                this.$nextTick(function () {
                    tools.imgToSvg()
                })
            }); 
        }
    },
    props: {
			TabClassRequest: {
				type: Boolean,
				default() {
					return true
				}
			},
            typeStudent: {
				type: Boolean,
				default() {
					return true
				}
			}
		}
}
</script>

